// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryBox-module--container--2jFZ0","cardsWrapper":"CategoryBox-module--cardsWrapper--2iPE8","sectionTitle":"CategoryBox-module--sectionTitle--3vaOS"};